import {needAuth} from "../instance/Instance";

async function getDiligence(id) {
    console.log(">>> api : 실사 단건 조회")
    return  await needAuth.get('/diligence/'+ id, {
        headers: {'Cache-Control': 'no-cache', 'Pragma': 'no-cache'},
    });
}

async function getDiligenceList(search, pageable) {
    const start = performance.now();
    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;
    try{
        return  await needAuth.post('/diligence?'+pageStr,search);
    }catch (error){
        return error;
    }finally {
        const end = performance.now(); // 함수 호출 후 현재 시간 측정
        const executionTime = ((end - start)/1000).toFixed(2); // 함수 실행에 걸린 시간 계산
        console.log(`>>> api : 실사 리스트 조회 완료시간 : ${executionTime} 초`);
    }
}


async function createDiligence(diligence, files) {
    console.log(">>> api : 실사 등록")
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });
    formData.append(
        "diligenceRequestDto",
        new Blob([JSON.stringify(diligence)], { type: "application/json" })
    );
    return await needAuth.post(
        '/diligence/create',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );

}

async function updateSingleField(data) {
    return await needAuth.put('/diligence',data);
}

export async function comment(data) {
    return await needAuth.put('/diligence/comment',data);
}

export async function progressDiligenceStatus(data, status) {
    return await needAuth.put(`/diligence/progress/${status}`,data);
}



async function getDiligenceAssetInfo(assetId) {
    return await needAuth.get(`/diligence/diligence-asset/${assetId}`);
}

async function updateDiligenceHandler(id, handlerId, add) {
    if(add)
        return await needAuth.put(`/diligence/${id}/add-handler/${handlerId}`);
    else
        return await needAuth.delete(`/diligence/${id}/remove-handler/${handlerId}`);
}



export async function deleteDiligence(data) {
    const queryString = `id=${data.join(',')}`;
    try {
        return await needAuth.delete(`/diligence?${queryString}`);
    } catch (error) {
        return error;
    }
}

async function updateDiligenceAsset(id, assetId, add) {
    if(add)
        return await needAuth.put(`/diligence/${id}/add-asset/${assetId}`);
    else
        return await needAuth.delete(`/diligence/${id}/remove-asset/${assetId}`);
}

export async function updateDiligenceAssetMessage(id, assetId, message) {
    return await needAuth.put(`/diligence/${id}/update-asset/${assetId}`, message,  { headers: { 'Content-Type': 'text/plain' } });
}


async function qrCheck(id) {
    return await needAuth.get(`/qrCheck/${id}`);
}


async function getAssetsForDiligence(search, pageable) {
    const start = performance.now();
    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;
    try{
        const url =`/diligence/assets?` + pageStr;

        const res = await needAuth.post(url, search);
        return  res;
    }catch (error){
        return error;
    }finally {
        const end = performance.now(); // 함수 호출 후 현재 시간 측정
        const executionTime = ((end - start)/1000).toFixed(2); // 함수 실행에 걸린 시간 계산
        // console.log(`>>> api : 자산 리스트 조회 완료시간 : ${executionTime} 초`);
    }
}


async function checkDiligenceAsset(diligenceId, assetId, message) {
    const diligence = {
        diligence :{id:diligenceId},
        asset:{id: assetId},
        message: message
    }
    return await needAuth.post(`/diligence/done`, diligence);
}





export {getDiligence, getDiligenceList, createDiligence, updateSingleField, updateDiligenceHandler, getDiligenceAssetInfo, updateDiligenceAsset, qrCheck, getAssetsForDiligence, checkDiligenceAsset};